module.exports = __webpack_public_path__ + "static/media/lahaye ice center.a8dc1ce2.jpeg";